export default __webpack_public_path__ + "static/media/user-plus-solid.98f7dd8c.svg";